import React, { useState, useEffect, useContext } from 'react';
import { fetchStudentsForUser } from '../utils/serverFetchAndAddUtilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencilAlt, faCheckCircle, faTimesCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { CourseDesignContext } from '../context/CourseDesignContext'; // 
import GradingInterface from './GradingInterface';
import { CourseIDContext } from '../context/CourseIDContext';
import { StudentGradesContext } from '../context/StudentGradesContext';

// import css
import './GradingStudentList.css';
//import { fetchGradesForExamColumns } from '../utils/serverFetchAndAddUtilities';
import { AuthContext } from '../context/AuthContext';


const GradingStudentList = () => {
  const { username } = useContext(AuthContext);
  // eslint-disable-next-line no-unused-vars
  const [students, setStudents] = useState([]);
    // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true);
    // eslint-disable-next-line no-unused-vars
    const [error, setError] = useState(null);
  const { courseDesignState } = useContext(CourseDesignContext);
  const [gradingInterfaceOpen, setGradingInterfaceOpen] = useState(false);
  const [selectedEvaluationId, setSelectedEvaluationId] = useState(null);
  const [selectedUsername, setSelectedUsername] = useState(null);
  const { courseID } = useContext(CourseIDContext);
  const [spinnerLoading, setSpinnerLoading] = useState(false);

  
const { studentGradesState } = useContext(StudentGradesContext);

  const copySessionStorageToWindow = (targetWindow, attempt = 0) => {
    if (!targetWindow || attempt > 10) {
      return;
    }

    try {
      const keysToCopy = ['isLoggedIn', 'isInstructor', 'isTA', 'username', 'fullName'];
      keysToCopy.forEach((key) => {
        const value = window.sessionStorage.getItem(key);
        if (value !== null) {
          targetWindow.sessionStorage.setItem(key, value);
        }
      });
    } catch (error) {
      window.setTimeout(() => copySessionStorageToWindow(targetWindow, attempt + 1), 50);
    }
  };

  const handleGenerateStudentPDF = (studentUsername) => {
    if (typeof window === 'undefined') {
      return;
    }

    const pdfUrl = `/${courseID}/pdf?username=${encodeURIComponent(studentUsername)}`;
    const pdfWindow = window.open(pdfUrl, '_blank');
    if (pdfWindow) {
      copySessionStorageToWindow(pdfWindow);
      try {
        pdfWindow.opener = null;
      } catch (error) {
        // Ignore if clearing fails
      }
    }
  };

  



useEffect(() => {
  const loadStudents = async () => {
    setLoading(true);
    try {
        const studentsData = await fetchStudentsForUser(courseID, username);
        studentsData.sort((a, b) => {
            const lastNameA = a.fullname.split(" ").pop().toLowerCase();
            const lastNameB = b.fullname.split(" ").pop().toLowerCase();
            return lastNameA.localeCompare(lastNameB);
        });
        setStudents(studentsData);
        setError(null);
    } catch (err) {
        console.error('Error fetching students:', err);
        setError('Failed to load student data.');
    } finally {
        setLoading(false);
    }
};


  loadStudents();
}, [courseID]);


  if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;


 const dynamicColumns = courseDesignState
    .filter(item => item.dataType === 'evaluation')
    .sort((a, b) => new Date(a.questionCourseDate) - new Date(b.questionCourseDate))
    .map(item => ({
      id: item.dataID,
      name: item.dataText,
      sections: item.questionOptions,
      dueDate: item.questionCourseDate
    }));

 // whether oral exams are integrated in course
 const integrateOralExamsEnabled = courseDesignState.some(
   (item) => item.dataType === 'integrateOralExams' && item.dataText === 'Yes'
 );

 
    // function to return to list from grading interface
 

  const handleReturnFromGrading = () => {
  setSpinnerLoading(true); // Show spinner
  setTimeout(() => {
    window.location.reload(); // Force reload
  }, 250); // Delay for smooth transition
     setGradingInterfaceOpen(false);
  setSelectedEvaluationId(null);
  setSelectedUsername(null);
};

    
 // Function to handle viewing student work
const handleViewStudentWork = (username) => {
  const url = `/${courseID}/grading?viewWork=${encodeURIComponent(username)}`;
  window.open(url, '_blank');
};


if (spinnerLoading) {
  return (
    <div className="loading-overlay">
      <div className="spinner"></div>
    </div>
  );
}


    // function to move to grading interface

const handleGrading = (evaluationId, username) => {
  // Build the URL with query parameters
  const gradingUrl = `/${courseID}/grading?evaluationId=${evaluationId}&username=${username}`;
  window.open(gradingUrl, '_blank');
};

      // if the user clicks on an exam to grade, the grading interface will open. Trigger ensures fresh data
  
if (gradingInterfaceOpen) {
  return (
    <GradingInterface
      evaluationId={selectedEvaluationId}
      username={selectedUsername}
      onReturn={handleReturnFromGrading}
    />
  );
}

    
 return (
    <div className="grading-student-list">
      <table>
        <thead>
          <tr>
            <th>Student Name</th>
            <th>View Work</th>
            <th>PDF</th>
            {dynamicColumns.map((column) => (
              <React.Fragment key={column.id}>
                <th>{column.name}</th>
                {integrateOralExamsEnabled && <th>Oral Exam</th>}
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((student) => (
            <tr key={student.username}>
              <td>{student.fullname}</td>
              <td>
                <div className="button-container">
                <button 
                  className="view-work-button" 
                  aria-label={`View work of ${student.fullname}`} 
                  onClick={() => handleViewStudentWork(student.username)}
                  
                >
                  <FontAwesomeIcon icon={faEye} />
                  </button>
                  </div>
              </td>
              <td>
                <div className="button-container">
                  <button
                    className="view-work-button"
                    aria-label={`Generate PDF of ${student.fullname}'s work`}
                    onClick={() => handleGenerateStudentPDF(student.username)}
                  >
                    <FontAwesomeIcon icon={faFilePdf} />
                  </button>
                </div>
              </td>
             {dynamicColumns.map((column) => {
  
                const studentGrades = studentGradesState[student.username] || [];

  const gradingComplete = studentGrades.find(
    (g) =>
      g.evaluationDataID === column.id &&
      g.gradingType === 'gradingComplete' &&
      g.individualGradingData === 'yes'
  );

  const examGrade = studentGrades.find(
    (g) =>
      g.evaluationDataID === column.id &&
      g.gradingType === 'examGrade'
  );

  const oralExamComplete = studentGrades.find(
    (g) =>
      g.evaluationDataID === column.id &&
      g.gradingType === 'oralExamComplete' &&
      g.individualGradingData === 'yes'
  );

  return (
    <React.Fragment key={column.id}>
      <td>
        <div className="button-container">
          {gradingComplete && examGrade ? (
            <button
              className="completed-grade-button"
              aria-label={`View grade for ${column.name} for ${student.fullname}`}
              onClick={() => handleGrading(column.id, student.username)}
            >
              {Number(examGrade.individualGradingData).toFixed(1)}
            </button>
          ) : (
            <button
              className="grade-button"
              aria-label={`Grade ${column.name} for ${student.fullname}`}
              onClick={() => handleGrading(column.id, student.username)}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </button>
          )}
        </div>
      </td>
      {integrateOralExamsEnabled && (
        <td className="oral-exam-cell">
          {oralExamComplete ? (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="oral-status-icon complete"
              title="Oral exam complete"
            />
          ) : (
            <FontAwesomeIcon
              icon={faTimesCircle}
              className="oral-status-icon incomplete"
              title="Oral exam incomplete"
            />
          )}
        </td>
      )}
    </React.Fragment>
  );
})}

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GradingStudentList;
